<template>
    <v-navigation-drawer
        :width="$vuetify.breakpoint.smAndDown ? '85%' : 290"
        app
        floating
        v-model="isLeftNavVisible"
        :temporary="$vuetify.breakpoint.smAndDown"
        :permanent="$vuetify.breakpoint.mdAndUp">
        <v-list>
            <v-list-item>
                <v-list-item-content style="position:relative;">
                    <v-img
                        contain
                        max-height="25px"
                        src="/img/logo.png"></v-img>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <v-list
            nav
            dark
            dense>
            <v-list-item
                v-for="(route) in collect(leftRoutes).all()"
                :key="route.name"
                :to="route.path"
                link>
                <v-list-item-icon>
                    <v-icon>{{ route.meta.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>
                        {{ route.meta.title }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <template v-slot:append>
            <left-bottom/>
        </template>
    </v-navigation-drawer>
</template>

<script>
import {mapGetters} from 'vuex';
import store from "../../../App/Store";
import LeftBottom from "./LeftBottom";

export default {
    components: {
        LeftBottom
    },

    computed: {
        ...mapGetters({
            user: 'auth/user',
        }),

        leftRoutes: function () {
            return this.$router.options.routes.filter(function (route) {
                return route.meta && route.meta.menu && route.meta.menu.toLowerCase() === "left";
            });
        },

        isLeftNavVisible: {
            get: function () {
                return store.getters.getLeftNavVisibility;
            },
            set: function (value) {
                store.dispatch('toggleLeftNavVisibility', value);
            }
        }
    },
};
</script>
